module.exports = __webpack_public_path__ + "img/illustration-5.7b9c51c7.svg";